module.exports = require('../../es/array');
